import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function Comments({ searchObject, onChange, t }) {
  return (
    <>
      <div>
        <legend className="fontsize-legend">{t("Comments")}</legend>
        <input
          className="form-control fontsize-legend"
          name="comments"
          onChange={onChange}
          value={searchObject.comments || ""}
        />
      </div>
    </>
  );
}
